import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CountriesState } from "./countries.state";

export const selectCountryState = createFeatureSelector<CountriesState>('countries');

export const selectCountries = createSelector(
  selectCountryState,
  (countriesState) => countriesState.countries
);